import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { ApplicationRef } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

import * as Sentry from '@sentry/angular';
import { browserTracingIntegration } from '@sentry/angular';
import { environment } from './environments/environment';
import {
  shouldIgnoreAbortUnhandledRejectionWithoutStack,
  shouldIgnoreAngularRouterNoMatchError,
  shouldIgnoreBlockedWebStorageAccess,
  shouldIgnoreChromeAndroidIllegalAccessNoise,
  shouldIgnoreClientNetworkFailureToOwnApi,
  shouldIgnoreInAppBrowserBridgeError,
  shouldIgnoreInAppBrowserSyntaxErrorWithoutAppStack,
  shouldIgnoreNgswVersionCheckNetworkFailure,
  shouldIgnoreRdStationLoaderReferenceError,
  enrichLazyChunkLoadFailureEvent,
  isLazyChunkLoadFailure,
  tryRecoverFromLazyChunkFailure,
} from './app/sentry/sentry-event-filter';

if (typeof window !== 'undefined') {
  window.addEventListener('unhandledrejection', (event) => {
    // Recovery em andamento: engole. Exhausted: também preventDefault — ErrorHandler + beforeSend
    // são a fonte canônica do evento taggeado (evita duplicata ruidosa no Safari).
    if (tryRecoverFromLazyChunkFailure(event.reason)) {
      event.preventDefault();
      return;
    }
    if (isLazyChunkLoadFailure(event.reason)) {
      event.preventDefault();
    }
  });
}

if (environment.production) {
  Sentry.init({
    dsn: 'https://c9e2108ed09053af7a52e670e4625393@o4509752765906944.ingest.us.sentry.io/4509752768790528',
    integrations: [browserTracingIntegration(), Sentry.replayIntegration()],
    // Scripts injetados pelo IAB do Instagram/Facebook (ex.: navigation_performance_logger_android).
    denyUrls: [/iabjs:\/\//i],
    tracesSampleRate: 1.0,
    environment: environment.environment,
    release: environment.version,
    sendDefaultPii: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event) {
      if (shouldIgnoreAngularRouterNoMatchError(event)) {
        return null;
      }

      if (shouldIgnoreInAppBrowserBridgeError(event)) {
        return null;
      }

      if (shouldIgnoreInAppBrowserSyntaxErrorWithoutAppStack(event)) {
        return null;
      }

      if (shouldIgnoreBlockedWebStorageAccess(event)) {
        return null;
      }

      let apiHostname = '';
      try {
        apiHostname = new URL(environment.apiUrl).hostname;
      } catch {
        /* ignore */
      }
      if (apiHostname && shouldIgnoreClientNetworkFailureToOwnApi(event, apiHostname)) {
        return null;
      }

      if (shouldIgnoreRdStationLoaderReferenceError(event)) {
        return null;
      }

      if (shouldIgnoreChromeAndroidIllegalAccessNoise(event)) {
        return null;
      }

      if (shouldIgnoreAbortUnhandledRejectionWithoutStack(event)) {
        return null;
      }

      if (shouldIgnoreNgswVersionCheckNetworkFailure(event)) {
        return null;
      }

      // 2ª falha de lazy chunk (recovery esgotado: 1HZ/1JS/…). Não dropa — agrupa e baixa severidade.
      return enrichLazyChunkLoadFailureEvent(event);
    },
  });
}

registerLocaleData(localePt);

if (typeof window !== 'undefined') {
  // Bloqueia pinch-to-zoom no iOS Safari
  document.addEventListener('gesturestart', (e) => e.preventDefault());

  // Bloqueia double-tap zoom em qualquer browser móvel
  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      const now = performance.now();
      if (now - lastTouchEnd <= 300) {
        e.preventDefault();
      }
      lastTouchEnd = now;
    },
    { passive: false },
  );
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    /* const applicationRef = appRef.injector.get(ApplicationRef);
    applicationRef.isStable.subscribe((stable) => {
      console.log('🟢 App estável?', stable);
    }); */
  })
  .catch((err) => console.error(err));
